import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ConditionSerializer2v4zqxahhdocs as ConditionSerializer } from './ConditionSerialization.mjs';
import { ModificationSerializer36sautdazlmsc as ModificationSerializer } from './ModificationSerialization.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.MassModification', null, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('condition', false);
        tmp0_serialDesc.addElement_5pzumi_k$('modification', false);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_qelnde_k$(typeSerial0) {
        return $serializer().new_com_lightningkite_services_database_MassModification_$serializer_srelal_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_services_database_MassModification_$serializer_pxlprn_k$();
      }
      static new_com_lightningkite_services_database_MassModification_$serializer_pxlprn_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.MassModification', $this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('condition', false);
        tmp0_serialDesc.addElement_5pzumi_k$('modification', false);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_8t1912_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, new (ConditionSerializer())(this.typeSerial0__1), value.condition_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, new (ModificationSerializer())(this.typeSerial0__1), value.modification_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_8t1912_k$(encoder, value instanceof MassModification() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (ConditionSerializer())(this.typeSerial0__1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (ModificationSerializer())(this.typeSerial0__1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (ConditionSerializer())(this.typeSerial0__1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (ModificationSerializer())(this.typeSerial0__1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return MassModification().new_com_lightningkite_services_database_MassModification_3c6hqz_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (ConditionSerializer())(this.typeSerial0__1), new (ModificationSerializer())(this.typeSerial0__1)];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_services_database_MassModification_$serializer_srelal_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_services_database_MassModification_$serializer_pxlprn_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var MassModificationClass;
function MassModification() {
  if (MassModificationClass === VOID) {
    class $ {
      constructor(condition, modification) {
        Companion_getInstance();
        this.condition_1 = condition;
        this.modification_1 = modification;
      }
      toString() {
        return 'MassModification(condition=' + toString(this.condition_1) + ', modification=' + toString(this.modification_1) + ')';
      }
      hashCode() {
        var result = this.condition_1.hashCode();
        result = imul(result, 31) + hashCode(this.modification_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MassModification()))
          return false;
        if (!this.condition_1.equals(other.condition_1))
          return false;
        if (!equals(this.modification_1, other.modification_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_MassModification_3c6hqz_k$(seen0, condition, modification, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, Companion_getInstance().$cachedDescriptor_1);
        }
        var $this = createThis(this);
        $this.condition_1 = condition;
        $this.modification_1 = modification;
        return $this;
      }
    }
    initMetadataForClass($, 'MassModification', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    MassModificationClass = $;
  }
  return MassModificationClass;
}
//region block: exports
export {
  MassModification as MassModification2547e91qtpdf9,
  Companion_getInstance as Companion_getInstancemcidlsfrtpdg,
};
//endregion

//# sourceMappingURL=MassModification.mjs.map
